function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(9.055)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  d: "M127.914,2.047a6.2,6.2,0,0,0-8.769,0l-6.07,6.07,8.777,8.777,6.062-6.078A6.206,6.206,0,0,0,127.914,2.047Zm-6.222,3.588-2.763,2.723-.008.008a.8.8,0,1,1-1.113-1.145L120.579,4.5l.008-.008a.8.8,0,1,1,1.105,1.145Z",
  transform: "translate(-113.075 -0.23)"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 9.016)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  d: "M7.918,112.818l-6.11,6.118a6.218,6.218,0,0,0,8.817,8.769l6.078-6.1Z",
  transform: "translate(0 -112.818)"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(21.116 21.077)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  d: "M272.316,263.418l-8.641,8.649a6.165,6.165,0,0,0,8.641-8.649Z",
  transform: "translate(-263.675 -263.418)"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(18.705 18.674)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  d: "M239.741,233.418a6.169,6.169,0,0,0-4.893,9.922l8.641-8.641A6.1,6.1,0,0,0,239.741,233.418Z",
  transform: "translate(-233.575 -233.418)"
}));

const SvgIconDrugs = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31.037,
    height: 31,
    viewBox: "0 0 31.037 31",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconDrugs, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Icon_Drugs.f39a249d.svg";
export { ForwardRef as ReactComponent };